import React, { useEffect, useState } from "react";
import { Tooltip, Select, message } from "antd";
import { Helmet } from "react-helmet";
import PerformanceService from "../../../Services/performanceService";
import DataParser from "../../../utlits/Dataparser";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

message.config({ zIndex: 1000000001 });

const { Option } = Select;

const AddPerformancePeriod = () => {
  const companyid = DataParser.CompanyId();

  const [period, setPeriod] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchPeriod = async () => {
      setLoading(true);
      try {
        const res = await PerformanceService.getPerformancePeriod(companyid);
        const data = res.data.performanceperiod?.[0];
        if (data) {
          setUpdateId(data.id);
          setPeriod(data.period || null);
        } else {
          setUpdateId(null);
          setPeriod(null);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPeriod();
  }, [companyid]);

  const handleProceed = async () => {
    document.getElementById("closeConfirmPerfModal").click();
    setSubmitting(true);
    try {
      await PerformanceService.createPerformancePeriod({
        company_id: companyid,
        period: period,
      });
      message.success("Performance period created successfully!");
      const res = await PerformanceService.getPerformancePeriod(companyid);
      const data = res.data.performanceperiod?.[0];
      if (data) {
        setUpdateId(data.id);
        setPeriod(data.period || null);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to create performance period.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmitClick = () => {
    if (!period) {
      message.error("Please select a period first!");
      return;
    }
    document.getElementById("openConfirmPerfModal").click();
  };

  return (
    <>
      <Helmet>
        <title>Performance Evaluation Period - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-center justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <style>{`
                    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
                      border-color: #1D1D1D !important;
                      box-shadow: none !important;
                      outline: none !important;
                    }
                    .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
                      border-color: #1D1D1D !important;
                    }
                  `}</style>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0 pt-3">
                    {loading ? (
                      <Skeleton height={280} borderRadius={12} />
                    ) : (
                      <div className="d-flex align-items-center" style={{ gap: "12px", maxWidth: "480px" }}>
                        <div className={`float-select-wrap ${period ? "has-value" : ""}`} style={{ flex: 1 }}>
                          <label>Performance Period</label>
                          <Select
                            placeholder=""
                            value={period}
                            onChange={(v) => setPeriod(v)}
                            disabled={!!updateId || submitting}
                            allowClear
                          >
                            <Option value="Weekly">Weekly</Option>
                            <Option value="Monthly">Monthly</Option>
                            <Option value="Quarterly">Quarterly</Option>
                            <Option value="Semi-Annually">Semi-Annually</Option>
                            <Option value="Annually">Annually</Option>
                          </Select>
                        </div>

                        <Tooltip
                          title={updateId ? "One performance period is already active." : ""}
                          color="#ffcccc"
                          overlayClassName="tooltip-no-arrow"
                          overlayInnerStyle={{ color: "#b30000", fontWeight: 500 }}
                        >
                          <div style={{ display: "inline-flex", flexShrink: 0 }}>
                            <button
                              disabled={!!updateId || submitting}
                              className="btn btn-primary"
                              style={{
                                borderRadius: "5px",
                                padding: "0 20px",
                                height: "43px",
                                overflow: "hidden",
                                pointerEvents: updateId || submitting ? "none" : "auto",
                                opacity: updateId ? 0.6 : 1,
                                cursor: updateId || submitting ? "not-allowed" : "pointer",
                                whiteSpace: "nowrap",
                              }}
                              onClick={handleSubmitClick}
                            >
                              {submitting ? "Submitting..." : "Submit"}
                            </button>
                          </div>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for confirm modal */}
        <div id="openConfirmPerfModal" data-bs-toggle="modal" data-bs-target="#confirmPerfModal" style={{ display: "none" }} />

        {/* Confirmation Modal */}
        <div id="confirmPerfModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Confirm Performance Period</h5>
                <button type="button" className="btn-close" id="closeConfirmPerfModal" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: 0 }}>
                  Once you have selected this period, this can only be changed within the first 15 days of the next Annual Leave Period.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light"
                  onClick={handleProceed}
                  style={{ borderRadius: "5px", fontSize: "13px" }}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPerformancePeriod;
